import { Price } from '../types';

export const isPriceNonZero = (price?: Price): boolean => !!(price?.min || price?.max || price?.fallback);
